import axios from 'axios'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_CATALOGACAO_RELATORY = createAsyncConst(
  'FETCH_CATALOGACAO_RELATORY'
)
export const MAKE_CATALOGACAO_RELATORY = createAsyncConst(
  'MAKE_CATALOGACAO_RELATORY'
)

export function fetchCatalogacaoRelatory(filters = {}) {
  return dispatch => {
    dispatch(action(FETCH_CATALOGACAO_RELATORY.ACTION))
    return axios
      .get(`${config.API_URL}/service-item-catalogs`, {
        params: filters,
      })
      .then(resp => {
        dispatch(
          action(FETCH_CATALOGACAO_RELATORY.SUCCESS, { data: resp.data })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_CATALOGACAO_RELATORY.FAILURE, e)))
  }
}

export function makeRelatory(data) {
  return dispatch => {
    return axios({
      url: `${config.API_URL}/service-item-catalogs`,
      method: 'GET',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      params: {
        ...data,
        download: true,
      },
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'catalogacao_report.xlsx')
        document.body.appendChild(link)
        link.click()
        return resp
      })
      .catch(e => dispatch(actionFailed(MAKE_CATALOGACAO_RELATORY.FAILURE, e)))
  }
}
